import {FileTextOutlined} from "@ant-design/icons";
import React from "react";
import {CohortDataset} from "../../HealthcareUsageReport/types/CohortQuery";
import {MenuItemType} from "antd/lib/menu/hooks/useItems";

export const COHORT_BUILDER_DATASETS = [
    {
        label: 'Hospital Episode Statistics',
        key: 'HES',
        code: 'HES',
        icon: <FileTextOutlined style={{color: '#F561B1'}}/>,
    },
    {
        label: 'Primary Care Activity Data',
        key: 'OPCRD',
        code: 'PCAD',
        icon: <FileTextOutlined style={{color: '#3677F2'}}/>,
    },
]

export const findDataset = (dataset: string) => {
    return COHORT_BUILDER_DATASETS.find((e) => e.key === dataset);
}

export const permittedChoices = (permittedDatasets: CohortDataset[]): MenuItemType[] => {
    return permittedDatasets.map(i => findDataset(i.toString())!)
}